import { useCallback } from 'react';
import type { VignetteValue } from '../../lib/filters/vignette';
import type { AdjustmentPanelProps } from '../adjustments/registry';
import { RangeRow } from '../adjustments/RangeRow';

/** Vignette panel — signed amount + midpoint. */
export function VignettePanel({ value, onChange }: AdjustmentPanelProps<VignetteValue>) {
  const set = useCallback(
    (patch: Partial<VignetteValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );
  return (
    <div className="space-y-3">
      <RangeRow
        label="Amount"
        min={-100}
        max={100}
        step={1}
        value={value.amount}
        onChange={(v) => set({ amount: v })}
      />
      <RangeRow
        label="Midpoint"
        min={0}
        max={1}
        step={0.01}
        decimals={2}
        value={value.midpoint}
        onChange={(v) => set({ midpoint: v })}
      />
    </div>
  );
}
